import fetchAPI from '../fetchAPI';

interface callGetCompanyAgentsProps {
  companyId: string;
}

export const callGetCompanyAgents = async ({
  companyId
}: callGetCompanyAgentsProps): Promise<iResponse<Pagination<Agent>>> => {
  const response: iResponse<Pagination<Agent>> = await fetchAPI({
    method: `GET`,
    route: `company/${companyId}/agents`
  });

  // const {error} = response;
  // if (error) throw new ResponseError(error);
  return response;
};

export default callGetCompanyAgents;
